import Vue from 'vue'
import App from './App.vue'
import router from './router'
import firebase from 'firebase/app'
import 'firebase/auth';
import VueVisible from 'vue-visible'
import store from './store'
import axios from 'axios'
import vuetify from './plugins/vuetify'
import VueTheMask from 'vue-the-mask'

// src/main.js
if (process.env.NODE_ENV === "development") {
  const script = document.createElement("script");
  script.src = "https://cdn.jsdelivr.net/npm/eruda";
  script.onload = () => eruda.init();
  document.body.appendChild(script);
}

Vue.use(VueVisible)
Vue.use(VueTheMask)

Vue.config.productionTip = false

const base = axios.create({
  //baseURL: 'https://uvrdev.csigaver.hu/diak_services' // TESZT SZERVER
  baseURL: 'https://diak.csigaver.hu/diak_services'
  //baseURL: 'https://elszam.csigaver.hu/diak_services' //PROD URL
})

Vue.prototype.$http = base
//Vue.prototype.$url = 'https://uvrdev.csigaver.hu/diak_services' // TESZT SZERVER
Vue.prototype.$url = 'https://diak.csigaver.hu/diak_services'
//Vue.prototype.$url = 'https://elszam.csigaver.hu/diak_services' //PROD URL

Vue.prototype.$eventBus = new Vue()

let app = ''

var config = {
  apiKey: 'AIzaSyCVZrtHLaPmpsigDW1FbquB9U7e7D4_oQs',
  authDomain: 'diak-cfadf.firebaseapp.com',
  databaseURL: 'https://diak-cfadf.firebaseio.com',
  projectId: 'diak-cfadf',
  storageBucket: 'diak-cfadf.appspot.com',
  messagingSenderId: '389740676798'
}

firebase.initializeApp(config)

Vue.mixin({
  data () {
    return {
    }
  },
  methods: {
    gettoken: async function () {
      await firebase.auth().currentUser.getIdToken().then((idToken) => {
        this.token = idToken
      }).catch((error) => {
        alert(error)
      })
    },
  },
  mounted() {
    }
})

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  }
})
